module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetHigh@2x.63d9f00.webp";